import { Component, inject } from "@angular/core";
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from "@angular/forms";
import { UiKitModule } from "@app/ui-kit.module";
import { MonitoringCategory } from "@domain/product/monitoring/monitoring-product.service";
import { Modal, ModalRef } from "@odx/angular/components/modal";

export const MONITORING_CATEGORY_LABELS: Record<MonitoringCategory, string> = {
  [MonitoringCategory.PATIENT_MONITORS]: $localize`:@@monitoring.patientMonitors:Patienten Monitore`,
  [MonitoringCategory.CENTRAL_STATIONS]: $localize`:@@monitoring.centralStations:Central Stations`,
  [MonitoringCategory.TELEMETRY]: $localize`:@@monitoring.telemetries:Telemetries`,
  [MonitoringCategory.KVMS]: $localize`:@@monitoring.kvms:KVMs`,
  [MonitoringCategory.DISPLAYS]: $localize`:@@monitoring.displays:Displays`,
  [MonitoringCategory.UTILITY]: $localize`:@@monitoring.utilities:Utilities`,
};

@Component({
  selector: "app-select-monitoring-placeholder-modal",
  templateUrl: "./select-monitoring-placeholder-modal.component.html",
  styleUrl: "./select-monitoring-placeholder-modal.component.scss",
  imports: [UiKitModule, FormsModule, ReactiveFormsModule],
  standalone: true,
})
export class SelectMonitoringPlaceholderModalComponent implements Modal<MonitoringCategory[], MonitoringCategory> {
  public readonly modalRef: ModalRef<MonitoringCategory[], MonitoringCategory>;

  protected readonly categoryLabels = MONITORING_CATEGORY_LABELS;
  protected categoryForm: FormGroup;
  protected categories: MonitoringCategory[];

  constructor() {
    const formBuilder = inject(FormBuilder);
    const modalRef = inject<ModalRef<MonitoringCategory[], MonitoringCategory>>(ModalRef);

    this.modalRef = modalRef;
    this.categories = modalRef.data;
    this.categoryForm = formBuilder.group({
      category: [this.categories[0], [Validators.required]],
    });
  }

  onConfirm() {
    this.modalRef.close(this.categoryForm.value.category);
  }
}
